import { breakpoints, theme, ThemeDefinition } from "@shapeable/theme";
import { Color } from "@shapeable/types";
import { css } from "styled-components";

export const YELLOW = '#FFCA04';
export const YELLOW_DARK = '#FCB10F';
export const YELLOW_ORANGE = '#F79616';

export const PRIMARY = '#ED683F'
export const PRIMARY_LIGHT = '#F79616';
export const PRIMARY_DARK = '#b84c2b';

export const SOFT_BLUE = '#bcdaf0';
export const NEUTRAL_BACKGROUND = '#f4ede5';
export const PALE_ORANGE = '#edc9ad';

export const DOING_SUNSHINE = '#F7D566';
export const DOING_DEEP_BLUE = '#0F2450';
export const DOING_SIGNAL_BLUE = '#5486F5';
export const DOING_CHALK = '#F3F0EB';

export const BRAND_COLORS = [PRIMARY, PRIMARY_LIGHT, PRIMARY_DARK, DOING_SUNSHINE, DOING_DEEP_BLUE, DOING_SIGNAL_BLUE];

export const PRIMARY_COLOR: Color = {
  id: 'primary',
  slug: 'primary',
  value: PRIMARY,
};
export const themeOverrides: ThemeDefinition = {
  font: {
    family: {
      sans: "'Manrope', 'IBM Plex Sans', sans-serif",
      serif: "'PP Agrandir', 'IBM Plex Sans', sans-serif",
      heading: "'PP Agrandir', 'IBM Plex Sans', sans-serif",
      copy: "'Manrope', 'IBM Plex Sans', sans-serif",
    },
  },
  light: {
    color: {

      darkBackground: '#202124',
      lightBackground: '#F8F8F8',

      midBrand: DOING_SUNSHINE,
      primary: PRIMARY,
      secondary: PRIMARY_LIGHT,

      appChrome: DOING_CHALK,
      subtleChrome: '#F8F8F5',


      linkHover: PRIMARY_DARK,
      link: PRIMARY,
      // linkInvertedHover: YELLOW,
      // linkActive: YELLOW,

      // menuItemLinkHover: YELLOW_DARK, 
      // menuItemLinkActive: YELLOW_DARK, 
      // invertedMenuItemLinkHover: YELLOW_DARK, 

    },
  },
  dark: {
    color: {
      darkBackground: '#202124',
      lightBackground: '#F8F8F8',
      midBrand: DOING_SUNSHINE,
      primary: PRIMARY,
    },
  },
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`
     .shp--site-menu-bar__utility-buttons {
      > .shp--site-header-utility-button:first-child {
        ${theme.FILL('light')}
      }
    }

    /* FOR ALL SLICE LAYOUTS - SCOTT REQUESTED WE REDUCE THIS GAP BETWEEN PARAGRAPHS */
    .shp--slice-layout {
      .shp--content-entity-block__content {
        .shp--content {
          p {
            margin-bottom: 1.1em;
          }
          li {
            margin-bottom: 0.5em;
          }
        }
      }
    }

    .shp--organisation-powered-by {
      img {
        filter: grayscale(1);
      }
      &:hover {
        filter: none;
      }
    }

   

    .shp--entity-card__title {
      font-family: ${theme.FONT('serif')};
    }

    .shp--entity-explorer-layout {
      background: white;
      .shp--site-header-layout {
        margin-bottom: ${theme.UNIT(6)};
      }
    }


    .shp--slice-layout-content-with-image,
    .shp--slice-layout-content-with-image-reverse {
      .shp--content-entity-block {
        .shp--content-entity-block__title {
          font-size: 2.5em;
          font-family: ${theme.FONT('heading')};
          line-height: 1.1em;
        }
        .shp--content-entity-block__subtitle {
          line-height: 1.40em;
        }
      }
      .shp--slice-block-image__layout {
        img {
          border-radius: ${theme.UNIT(5)};
        }
      }
    }

    #work-with-us .shp--slice-layout-content-with-image-reverse {
      .shp--content-entity-rich-title {
        strong {
          color: white;
        }
      }
    }

    #how-it-works .shp--slice-layout-content-with-image {
      .shp--content {
        strong {
          color: white;
        }
      }
    }

    #events-workshops .shp--slice-layout-content-with-image {
      .shp--content-entity-rich-title {
        strong {
          color: white;
          font-size: 2em;
          margin-bottom: ${theme.UNIT(8)};
        }
      }
      .shp--slice-block-image__layout {
        img {
          width: 100%;
        }
      }
    }

    /* For Events listing page */
    
    #festival-of-doing .shp--slice-block-image__layout {
      .shp--content {
        strong {
          color: ${theme.COLOR('light')};
          font-weight: 600;
        }
      }
      .shp--button {
        filter: brightness(1.1);
      }
    }

    #we-are-a-collective .shp--slice-layout-content-with-image,
    #we-are .shp--slice-layout-content-with-image,
    #programs-and-courses .shp--slice-layout-content-with-image-reverse,
    #unlock .shp--slice-layout-content-with-image,
    #the-movement-home .shp--slice-layout-content-with-image,
    #work-with-us .shp--slice-layout-content-with-image-reverse,
    #turning-ideas .shp--slice-layout-content-with-image,
    #this-is-where-the-fun-starts .shp--slice-layout-content-with-image,
    #bentley-together-events .shp--slice-layout-content-with-image,
    #events-workshops .shp--slice-layout-content-with-image {
      .shp--slice-block-image__layout {
        img {
          width: 100%;
        }
      }
    }

    #news-header .shp--slice-layout-header {
      h2 {
        font-size: 2em;
      }
    }

    .shp--slice-layout-header {
      .shp--slice-header {
        font-family: ${theme.FONT('sans')};
        font-weight: 600;
      }
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      flex-direction: column;
      gap: 0.25em;

      h1 {
        align-self: flex-start;
      }
    }

    .shp--slice-intro {
      font-size: 1.75em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--site-menu-bar__title {
      color: ${theme.COLOR('light')}
    }

    .shp--slice-key-message {
      text-align: left;

      .shp--content {
        line-height: 1.10em;
        font-family: ${theme.FONT('sans')};
        font-weight: 400;
      }
      
      .shp--slice-key-message__links {
        align-items: flex-start;
      }
    }

    .shp--slice-layout-person-grid {
      .shp--entity-bubble-image {
        height: 160px;
        width: 160px;
        border-radius: ${theme.UNIT(4)};
        img {
          border-radius: ${theme.UNIT(4)};
        }
      }
      .shp--person-bio-cell__body {
        align-items: center;
        text-align: left;
      }
    }

  `,
  tablet: css`
    .shp--slice-intro {
      font-size: 2em;
      text-align: left;
      line-height: 1.25em;
    }

    #we-are-a-collective .shp--slice-layout-content-with-image,
    #we-are .shp--slice-layout-content-with-image,
    #programs-and-courses .shp--slice-layout-content-with-image-reverse,
    #unlock .shp--slice-layout-content-with-image,
    #the-movement-home .shp--slice-layout-content-with-image,
    #work-with-us .shp--slice-layout-content-with-image-reverse,
    #turning-ideas .shp--slice-layout-content-with-image,
    #this-is-where-the-fun-starts .shp--slice-layout-content-with-image,
    #bentley-together-events .shp--slice-layout-content-with-image,
    #events-workshops .shp--slice-layout-content-with-image {
      .shp--content-entity-block {
        .shp--content-entity-block__title {
          font-size: 2.8em;
        }
      }
      .shp--slice-block-image__image-container {
        width: 60%;
      }
    }

    #news-header .shp--slice-layout-header {
      h2 {
        font-size: 2.8em;
      }
    }

    .shp--slice-layout-person-grid {
      .shp--person-bio-cell__body {
        align-items: flex-start;
        text-align: left;
      }
    }

  `,
  desktop: css`
    .shp--slice-section-color-block {
      min-height: 600px;
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      gap: 1em;
    }

    #news-header .shp--slice-layout-header {
      h2 {
        font-size: 4em;
      }
    }

    #we-are-a-collective .shp--slice-layout-content-with-image,
    #we-are .shp--slice-layout-content-with-image,
    #programs-and-courses .shp--slice-layout-content-with-image-reverse,
    #unlock .shp--slice-layout-content-with-image,
    #the-movement-home .shp--slice-layout-content-with-image,
    #work-with-us .shp--slice-layout-content-with-image-reverse,
    #turning-ideas .shp--slice-layout-content-with-image,
    #this-is-where-the-fun-starts .shp--slice-layout-content-with-image,
    #bentley-together-events .shp--slice-layout-content-with-image,
    #events-workshops .shp--slice-layout-content-with-image {
      .shp--content-entity-block {
        .shp--content-entity-block__title {
          font-size: 4em;
        }
      }
    }
    
  `,
});